import { useSelector } from "react-redux"

const PartiesTabError = ({ actorType,children }) => {  
    const getErrorByActoryType=useSelector(state=>state.ValidationErrors.parties)
    const errorInfo = {
        name:getErrorByActoryType?.[`${actorType}.name`]?.msg,
        eoriNo:getErrorByActoryType?.[`${actorType}.eoriNo`]?.msg, 
        addressLine1:getErrorByActoryType?.[`${actorType}.addressLine1`]?.msg, 
        addressLine2:getErrorByActoryType?.[`${actorType}.addressLine2`]?.msg, 
        city:getErrorByActoryType?.[`${actorType}.city`]?.msg, 
        state:getErrorByActoryType?.[`${actorType}.state`]?.msg, 
        postalCode:getErrorByActoryType?.[`${actorType}.postalCode`]?.msg, 
    }

    return children(errorInfo)
}

export default PartiesTabError